interface AppConfig {
  ENVIRONMENT: "Integration" | "Production";
  API_URL: string;
  LINK_API_URL: string;
  CLIENT_ID: string;
  AUTH_HEADER: string;
}

interface ConfigWindow extends Window {
  AppConfig: AppConfig;
}

declare let window: ConfigWindow;

const config = window.AppConfig || {
  ENVIRONMENT: "Integration",
  API_URL: "https://api-integration.codat.io",
  LINK_API_URL: "https://link-api-integration.codat.io",
  CLIENT_ID: "cae1aa4f-e6e9-46d5-925b-1ebc4044f772",
  AUTH_HEADER: "Basic aE02MkE1b0w1MjB1YjNUYVNVS3IyUzd5NGJsRWJobnhiMGFiOExtNA==",
};

export default config;
